"use client"

import { Button, Text } from "@/elements"
import React, { FC, useRef } from "react"
import { DropDownItem } from "./TextInputWithDropdown"
import clsx from "clsx"

interface Props {
  items: DropDownItem[]
  onClickItem: (item: DropDownItem) => void
  onTabOut?: () => void
  dropdownPosition?: "above" | "below"
  searchString: string
  width?: string
  className?: string
}

export const DropdownMenu: FC<Props> = ({
  items = [],
  onTabOut,
  onClickItem,
  dropdownPosition = "below",
  width,
  searchString,
  className,
}) => {
  const lastItemRef = useRef<HTMLButtonElement | null>(null)

  const noResults = items.length === 0 && Boolean(searchString)

  return (
    <div
      className={clsx(
        "shadow-[0px_8px_25px_0px_rgba(0,0,0,0.2)])} absolute right-0 z-10 mt-2 w-[calc(100vw-32px)] overflow-hidden rounded-md border border-bg-3 bg-bg-1 p-4 sm:left-0 sm:right-auto sm:w-[400px]",
        dropdownPosition === "above" ? "bottom-full mb-2" : "top-full mt-2",
        width ? width : "w-[321px]",
        className
      )}>
      <div className="flex flex-col gap-2">
        {noResults ? (
          <Text>No results</Text>
        ) : (
          items.map((item, index) => (
            <div key={item.display + index} className="flex flex-grow-0">
              <Button
                tabIndex={0}
                className="menu-button"
                ref={index === items.length - 1 ? lastItemRef : null}
                variant="grey-fill"
                onClick={e => {
                  e.preventDefault()
                  onClickItem(item)
                }}>
                {item.display}
              </Button>
            </div>
          ))
        )}
      </div>
    </div>
  )
}
